import React from 'react';
import { connect } from 'react-redux';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { openLoginModal } from '../../redux/actions/authActions';
import { getCustomToast } from '../../components/ErrorMessage';

class ActivateAccount extends React.Component {
  componentDidMount() {
    this.activateAccount();
  }

  activateAccount = async () => {
    try {
      const { match, openLoginModal } = this.props;
      const { token } = match.params;

      const { status } = await api.putWithoutToken(endpoints.auth.activateAccount(token));

      if (status === 200) {
        getCustomToast(
          'We have successfully verified your account. Please login',
          'success'
        );
        openLoginModal();
      } else {
        throw new Error('Activation Failed: Status Not 200');
      }
    } catch (e) {
      this.props.history.replace('/signup/activation-failed');
    }
  };

  render() {
    return null;
  }
}

export default connect(
  null,
  { openLoginModal }
)(ActivateAccount);



// WEBPACK FOOTER //
// ./src/screens/Signup/ActivateAccount.jsx